import { Menu, ParkingSquare } from "lucide-react";
import { usePark } from "@/contexts/ParkContext";
import {
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from "@/components/ui/select";

/**
 * Mobile-only top bar (hidden on md+). Sticky at the top, hosts:
 *   - Hamburger button (opens the sidebar drawer)
 *   - Park Director logo + current park switcher
 */
export function MobileTopBar({ onMenu }) {
  const { parks, currentPark, switchPark } = usePark();
  return (
    <header
      className="md:hidden sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-[#EAEAE5] flex items-center gap-2 px-3 h-14"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
      data-testid="mobile-top-bar"
    >
      <button
        onClick={onMenu}
        className="h-11 w-11 -ml-1 flex items-center justify-center rounded-lg hover:bg-[#F0F0EC] active:bg-[#EAEAE5]"
        aria-label="Open navigation"
        data-testid="mobile-nav-toggle"
      >
        <Menu size={22} strokeWidth={2} />
      </button>
      <div className="flex items-center gap-2 min-w-0">
        <div className="w-8 h-8 rounded-md bg-[#284B3B] flex items-center justify-center text-white shrink-0">
          <ParkingSquare size={16} strokeWidth={2.2} />
        </div>
        <div className="text-[15px] font-semibold tracking-tight text-[#1A211D] truncate" style={{ fontFamily: "Outfit" }}>
          Park Director
        </div>
      </div>
      <div className="ml-auto min-w-0 max-w-[55%]">
        {parks.length > 0 && (
          <Select value={currentPark?.id || ""} onValueChange={switchPark}>
            <SelectTrigger className="h-10 bg-[#FAFAF7] border-[#EAEAE5] text-sm" data-testid="mobile-park-switcher">
              <SelectValue placeholder="Park…" />
            </SelectTrigger>
            <SelectContent>
              {parks.map((p) => (
                <SelectItem key={p.id} value={p.id} data-testid={`mobile-park-option-${p.id}`}>{p.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </div>
    </header>
  );
}
